import API from "./api";

const notificationApi = {
  list: () => API.get("/notifications"),
  markRead: (id) => API.patch(`/notifications/${id}/read`),
  markAllRead: () => API.patch("/notifications/read-all"),
};

export default notificationApi;
